export default __webpack_public_path__ + "static/media/Venus Transit 2023 affect your Zodiac Sign.e73243c9.png";